exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contact-jsx": () => import("./../../../src/pages/contact.jsx" /* webpackChunkName: "component---src-pages-contact-jsx" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-marques-jsx": () => import("./../../../src/pages/marques.jsx" /* webpackChunkName: "component---src-pages-marques-jsx" */),
  "component---src-pages-prestations-jsx": () => import("./../../../src/pages/prestations.jsx" /* webpackChunkName: "component---src-pages-prestations-jsx" */)
}

